module.exports = __webpack_public_path__ + "img/avatar-5.1010e405.png";